import { render } from "./AffiliateRegister.vue?vue&type=template&id=aba92e8c&scoped=true"
import script from "./AffiliateRegister.vue?vue&type=script&lang=js"
export * from "./AffiliateRegister.vue?vue&type=script&lang=js"

import "./AffiliateRegister.vue?vue&type=style&index=0&id=aba92e8c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba92e8c"]])

export default __exports__